import { render, staticRenderFns } from "./workshop-details.vue?vue&type=template&id=d24e46c8&scoped=true"
import script from "./workshop-details.vue?vue&type=script&lang=js"
export * from "./workshop-details.vue?vue&type=script&lang=js"
import style0 from "./workshop-details.vue?vue&type=style&index=0&id=d24e46c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d24e46c8",
  null
  
)

export default component.exports